import { Options } from 'react-hotkeys-hook'

export interface HotkeyConfig {
  keys: string
  description: string
  action: () => void
  options?: Options
}

export interface HotkeyDefinition {
  keys: string
  description: string
  route?: string
  customAction?: () => void
  options?: Options
}

const isMac = typeof navigator !== 'undefined' && navigator.platform.toLowerCase().includes('mac')

export const getDisplayKey = (key: string): string => {
  if (isMac) {
    return key
      .replace('ctrl', '⌘')
      .replace('cmd', '⌘')
      .replace('alt', '⌥')
      .replace('option', '⌥')
      .replace('shift', '⇧')
      .replace('+', '')
  }
  return key.toUpperCase()
}

export const getPlatformKey = (windowsKey: string, macKey?: string): string => {
  return isMac && macKey ? macKey : windowsKey
}

export const globalHotkeyDefinitions: Record<string, HotkeyDefinition> = {
  save: {
    keys: getPlatformKey('ctrl+s', 'meta+s'),
    description: 'Save current form'
  },
  newSales: {
    keys: 'alt+s',
    description: 'New Sales Invoice',
    route: '/sales-invoices/new'
  },
  paymentIn: {
    keys: 'alt+i',
    description: 'Payment In',
    route: '/payments-in/list'
  },
  paymentOut: {
    keys: 'alt+o',
    description: 'Payment Out',
    route: '/expenses/list'
  },
  estimate: {
    keys: 'alt+m',
    description: 'New Estimate/Quotation',
    route: '/quotations/detail'
  },
  expenses: {
    keys: 'alt+e',
    description: 'Expenses',
    route: '/expenses/list'
  },
  report: {
    keys: 'alt+r',
    description: 'Reports',
    route: '/dashboard'
  },
  help: {
    keys: 'alt+h',
    description: 'Show keyboard shortcuts'
  }
}

export const hotkeyOptions: Options = {
  enableOnFormTags: false,
  enableOnContentEditable: false,
  preventDefault: true,
  enabled: true,
  keyup: false,
  keydown: true
}

export const saveHotkeyOptions: Options = {
  enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
  enableOnContentEditable: true,
  preventDefault: true,
  enabled: true,
  keyup: false,
  keydown: true
}
